import styles from "./Divider.module.css";

interface Props {
  text?: string;
}

const Divider = ({ text }: Props) => {
  return <div className={styles.divider}>{text}</div>;
};

export default Divider;
